module.exports = __webpack_public_path__ + "img/brown_louis.7323c796.jpg";